import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { destroyTip } from "../../../../actions/mine_craft/tipsActions";
import { useNavigate } from "react-router-dom";
import { selectTipEntities, selectTipIds, setEditId } from "../../../../store/mine_craft/tipsSlice";
import usePermissions from "../../../../hooks/usePermissions";

import { message, Spin } from "antd";
import { FlagOutlined } from "@ant-design/icons";
import Pagination from '../../../../componets/Pagination';
import IconText from "../../../../componets/IconText";
import { ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";
import Card from "../../../../componets/Card";

interface propsInterface {
  limit: number;
}

const _List = ({ limit }: propsInterface) => {
  const navigate  = useNavigate();
  const dispatch  = useAppDispatch();
  const ids       = useAppSelector(selectTipIds);
  const tips      = useAppSelector(selectTipEntities);
  const count     = useAppSelector(state => state.mineCraft.tips.count);
  const error     = useAppSelector(state => state.mineCraft.tips.error);
  const status    = useAppSelector(state => state.mineCraft.tips.status);
  const { write_minecraft } = usePermissions();

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyTip(id));

    if (destroyTip.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroyTip.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  const renderTip = (id: EntityId) => {
    const tip = tips[id];

    if (!tip) {
      return;
    }

    const translationsCount = Object.keys(tip.title_translations).length;

    return (
      <Card.Inline
        key={tip.id}
        title={tip.title}
        link={tip.url}
        stats={[
          <IconText icon={FlagOutlined} text={translationsCount} />
        ]}
        options={write_minecraft ? [
          <ButtonEdit key={`edit-${tip.id}`} onClick={() => onClickEdit(tip.id)} />,
          <ButtonDestroy key={`destroy-${tip.id}`} onClick={() => onClickDestroy(tip.id)} />
        ] : []}
      />
    )
  }

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  return (
    <>
      {ids && ids.map(renderTip)}

      <Pagination total={count} size={limit} />
    </>
  );
}

export default _List;
